module.exports = __webpack_public_path__ + "img/DE02795.201e835f.png";